import { type AppBrand, appBrands } from '@b2ag/app-brands'
import { getAppTypeLocale } from '@b2ag/locale'

function productSEOTitle(
  {
    kind = '',
    family = '',
    supplier = '',
    name = '',
    categories = [],
    categoriesLevel1 = '',
    categoriesLevel2 = '',
    categoriesLevel3 = '',
  } = {},
  appContext: AppBrand = appBrands.default,
) {
  let title = ''
  let firstCategory = ''
  const appTypeLocale = getAppTypeLocale(appContext)
  if (categories.length > 0) {
    // @ts-ignore: migration de JS à TS, ne veut pas toucher à la logique
    firstCategory = categories[0][categories[0].length - 1].label
  }
  if (!firstCategory && (categoriesLevel3 || categoriesLevel2 || categoriesLevel1)) {
    const deepestCategoryLevel = (categoriesLevel3 || categoriesLevel2 || categoriesLevel1)[0] || ''
    firstCategory = deepestCategoryLevel.slice(deepestCategoryLevel.lastIndexOf('>') + 1)
  }

  const replaceMap = {
    '{$family}': family,
    '{$firstCategory}': firstCategory,
    '{$name}': name,
    '{$supplier}': supplier,
  }

  const titleTemplateByKind =
    appTypeLocale['v-product'].metadata.title[kind] ?? appTypeLocale['v-product'].metadata.title.default

  title = titleTemplateByKind.replace(/{\$(family|firstCategory|name|supplier)}/g, (key) => {
    return replaceMap[key] ?? ''
  })

  return title.trim().replace(/\s+/g, ' ')
}

function searchSEOTitle(family, category, appContext: AppBrand = appBrands.default, page: number = 0) {
  const appTypeLocale = getAppTypeLocale(appContext)

  return appTypeLocale['p-app-search'].metadata.title
    .replace('{$familyOrCategory}', () => {
      if (!family && !category) return appTypeLocale['p-app-search'].metadata.titleAllProducts
      return category || family
    })
    .replace('{$page}', () => {
      return page > 1 ? appTypeLocale['p-app-search'].metadata.titlePage.replace('{$page}', `${page}`) : ''
    })
}

export { productSEOTitle, searchSEOTitle }
